import React, { useEffect, useState } from 'react'
import { Translate } from 'react-localize-redux'
import {
  Dialog,
  Button,
  Checkbox,
  FormControlLabel,
  DialogContent,
  Box,
  Typography,
  TextField,
  DialogActions,
  DialogTitle,
  MenuItem,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { players as playersModule } from '../../../../redux/modules'
import useStyles from './RemovePlayerAccessStyles'

const TransferDestinationDialog = ({
  playerUuid,
  open,
  onClose,
  isChecked,
  setChecked,
  onSubmit,
  fetchTransferDestinations,
}) => {
  const [destinationTeams, setDestinationTeams] = useState([])
  const [teamUuid, setTeamUuid] = useState(null)

  useEffect(() => {
    if (!open) {
      return
    }

    // reset
    setDestinationTeams([])
    setTeamUuid(null)

    fetchTransferDestinations(playerUuid).then(({ response: { data } }) => {
      setDestinationTeams(data)
    })
  }, [open])

  const handleChange = (event) => {
    setChecked(event.target.checked)
  }
  const handleTeamChange = (e) => {
    setTeamUuid(e.target.value)
    // Prevent page crash due to data grid predefined method calling on Select list change
    e.stopPropagation()
  }

  const handleSubmit = () => {
    onSubmit(teamUuid, isChecked)
  }

  useEffect(() => {
    if (destinationTeams.length && !teamUuid) {
      setTeamUuid(destinationTeams[0].uuid)
    }
  }, [destinationTeams])

  const classes = useStyles()

  // @todo: #transfer add translations
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      className={classes.root}
    >
      <DialogTitle>
        <Translate id="movePlayers.transfer-player" />
      </DialogTitle>
      <DialogContent>
        <List component="ul" disablePadding className={classes.orderedList}>
          <ListItem className={classes.listItem}>
            <ListItemText
              primary={
                <Typography color="textSecondary">
                  <Translate id="movePlayers.current-team-assignment-will-remain-unchanged-unless-you-choose-to-archive-it" />
                </Typography>
              }
            />
          </ListItem>
          <ListItem className={classes.listItem}>
            <ListItemText
              primary={
                <Typography color="textSecondary">
                  <Translate id="movePlayers.player-with-the-same-profile-and-data-to-the-destination-team" />
                </Typography>
              }
            />
          </ListItem>
          <ListItem className={classes.listItem}>
            <ListItemText
              primary={
                <Typography color="textSecondary">
                  <Translate id="movePlayers.optionally-archive-the-player-in-this-team-to-remove-them-from-future-activities" />
                </Typography>
              }
            />
          </ListItem>
        </List>

        <TextField
          value={teamUuid || ''}
          onChange={handleTeamChange}
          select
          label={<Translate id="menu.team" />}
          placeholder={
            <Translate id="movePlayers.select-the-team-that-the-player-has-to-be-transferred-to" />
          }
          variant="outlined"
          required
          size="small"
        >
          {destinationTeams.map((t) => (
            <MenuItem key={t.uuid} value={t.uuid}>
              {t.name}
            </MenuItem>
          ))}
        </TextField>
        <Box>
          <FormControlLabel
            control={
              <Checkbox
                checked={isChecked}
                onChange={handleChange}
                color="primary"
              />
            }
            className={classes.formControlLabel}
            label={
              <Translate id="movePlayers.archive-player-in-current-team-after-transfer" />
            }
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          <Translate id="button.cancel" />
        </Button>
        <Button
          disabled={!teamUuid}
          onClick={handleSubmit}
          color="primary"
          variant="contained"
        >
          <Translate id="button.transfer" />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

TransferDestinationDialog.propTypes = {
  playerUuid: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  fetchTransferDestinations: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  setChecked: PropTypes.func.isRequired,
}

export default connect(null, {
  fetchTransferDestinations: playersModule.fetchPlayerTransferDestinations,
})(TransferDestinationDialog)
